import React from 'react'

export default function useMultilineText (text) {
    const elems = []
    text.split('\n').map((item, i) =>
        elems.push(<p key={i}>{item}</p>)
    )
    return elems
}
